export default __webpack_public_path__ + "static/media/aftersales_service.5e135bbc.c3ad8dea.jpg";